import { useEffect, useState } from "react";
import { Truck, ShieldCheck, Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { api } from "@/lib/api";
import { useSeo, pageSeo, graph, crumbs, PAGES } from "@/lib/seo";
import { PageHero } from "@/components/common/SectionHeading";
import { FeaturedProduct, ProductCard } from "@/components/shop/ProductCards";
import { accent } from "@/lib/ui";

const Assurances = () => {
  const { settings } = useSite();
  const items = [
    [Truck, settings.delivery_text],
    [ShieldCheck, settings.online_payments_enabled ? "Secure online payment via Razorpay — UPI, cards, net banking and wallets" : "Order easily on WhatsApp or by phone"],
    [Phone, `Order support: ${settings.phone_display}`],
  ];
  return (
    <ul className="grid gap-4 md:grid-cols-3">
      {items.map(([Icon, text], i) => (
        <li key={text} className="flex items-start gap-3 rounded-2xl bg-white p-5 ring-1 ring-slate-200/80">
          <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl shadow-md ${accent(i + 2).icon}`}><Icon className="h-5 w-5" aria-hidden="true" /></span>
          <span className="text-base text-slate-700">{text}</span>
        </li>
      ))}
    </ul>
  );
};

export default function Shop() {
  const [products, setProducts] = useState(null);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, [setProducts]);
  useSeo({ ...pageSeo("/shop"), image: "/images/spinefit-front.jpg", jsonLd: graph(crumbs(["Shop", "/shop"])) });
  return (
    <>
      <PageHero eyebrow="Shop" title={PAGES["/shop"].h1} intro={PAGES["/shop"].intro} />
      <div className="bg-gradient-to-b from-brand-tint via-white to-brand-greenTint pb-16 md:pb-24">
        <div className="container-x space-y-10 pt-2">
          {products === null && <div className="h-96 animate-pulse rounded-[2rem] bg-white" />}
          {products?.length === 0 && <p className="py-16 text-center text-base text-slate-600" data-testid="shop-empty">New products are coming soon.</p>}
          {products?.length === 1 && <FeaturedProduct product={products[0]} />}
          {products?.length > 1 && (
            <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {products.map((p) => <li key={p.id}><ProductCard product={p} /></li>)}
            </ul>
          )}
          <Assurances />
        </div>
      </div>
    </>
  );
}
